/**
 * @namespace source.folders.trash
 */
import { toFolder } from './mappers/folder';
import { toError } from './parsers/error';
import { MediaType } from '../../constants/MediaType';
export function initFoldersTrash(settings, http) {
  function mapFolderList(res) {
    res.data = (res.data.trash_folders || []).map(function (folder) {
      const newFolder = toFolder(folder);
      newFolder.isInTrash = true;
      return newFolder;
    });
    return res;
  }
  function list(folderId, options) {
    options = options || {};
    const queryParams = {
      media_type: options.mediaType || MediaType.Picture,
      folder_id: folderId || null,
      trash_type: 'folder'
    };
    return http.get(settings.apiUrl + "/files/getpage/trash", queryParams, {
      headers: options.headers || {}
    }).then(mapFolderList).catch(toError);
  }
  function removeFolder(folderId, options) {
    const url = settings.apiUrl + "/trash/folders/" + folderId + "/delete";
    const postOptions = {
      headers: options.headers || {}
    };
    return http.post(url, null, null, postOptions).then(function (res) {
      res.data = {
        id: folderId
      };
      return res;
    }).catch(toError);
  }
  function remove(folderIds, options) {
    options = options || {};
    return folderIds.map(function (folderId) {
      return removeFolder(folderId, options);
    });
  }
  function restoreFolder(folderId, options) {
    const url = settings.apiUrl + "/trash/folders/" + folderId + "/restore";
    const postOptions = {
      headers: options.headers || {}
    };
    return http.post(url, null, null, postOptions).then(function (res) {
      res.data = {
        id: folderId
      };
      return res;
    }).catch(toError);
  }
  function restore(folderIds, options) {
    options = options || {};
    return folderIds.map(function (folderId) {
      return restoreFolder(folderId, options);
    });
  }
  return {
    list,
    remove,
    restore
  };
}